import CloseIcon from "@mui/icons-material/Close";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Tooltip,
} from "@mui/material";
import { useState } from "react";
import { ReprocessFileMoveToPreflight } from "../../api/preworkDetailApi/preworkDetailApi";
import { useSnackbar } from "../Common/SnackbarContext";
import LocalStorageUtil from "../../utils/localStorage";
interface ReprocessSendToPreflightProps {
  isOpen: boolean;
  onClose: (isCancelClick: boolean, tabValue?: number) => void;
  title: string;
  selectedData: any;
  tabValue?: number;
}

const ReprocessSendToPreflight: React.FC<ReprocessSendToPreflightProps> = ({
  isOpen,
  onClose,
  title,
  selectedData,
  tabValue,
}) => {
  const [loading, setLoading] = useState<boolean>(false);
  const { showSnackbar } = useSnackbar();

  //Close the dialog box
  const handleNoClick = () => {
    onClose(true, undefined);
  };

  const handleSendClick = async () => {
    try {
      setLoading(true);     
      const sendToPreflight = selectedData.PreworkDetails.map((item: any) => ({
        ParentDocumentID: item.ParentDocumentID,
        documentStreamid: item.ChildFileDocumentStreamId,
        AccountId: Number(LocalStorageUtil.getItem("accountId")) || 0,
        Userid: Number(LocalStorageUtil.getItem("userId")) || 0,
        toPreflightJobNumber: item.ToPreflightJobNumber,
        fromPreflightJobNumber: item.FromPreflightJobNumber,
      }));
      
      const obj = {
        preworkDetails: sendToPreflight,
        InstructionId:
          selectedData.InstructionId === undefined
            ? null
            : selectedData.InstructionId,
        contextName: LocalStorageUtil.getItem("contextName") ?? "",
      };
      const response = await ReprocessFileMoveToPreflight(obj);
      if (response) {
        showSnackbar("Reprocess submitted successfully");
        onClose(false, tabValue);
      }
    } catch (error) {
      console.error("Error in ReprocessSendToPreflight ", error);
      throw error;
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <Dialog
        open={isOpen}
        onClose={handleNoClick}
        maxWidth="sm"
        PaperProps={{
          style: {
            height: "55%",
            width: "20%",
          },
        }}
      >
        <DialogTitle style={{ backgroundColor: "var(--primary-color)" }}>
          <div
            className="col-sm-12"
            style={{
              display: "flex",
              justifyContent: "left",
              alignItems: "center",
            }}
          >
            <div
              className="col-sm-11"
              style={{
                display: "flex",
                alignItems: "left",
                gap: "10px",
                color: "var(--aggrid-text-color)",
              }}
            >
              {title}
            </div>
            <div
              className="col-sm-1"
              style={{
                display: "flex",
                alignItems: "flex-end",
                justifyContent: "right",
              }}
            >
              {" "}
              <Tooltip title="Close">
                <IconButton
                  onClick={() => onClose(true)}
                  style={{
                    cursor: "pointer",
                    alignItems: "flex-end",
                    color: "var(--aggrid-text-color)",
                    width: "20px",
                  }}
                >
                  <CloseIcon />
                </IconButton>
              </Tooltip>
            </div>
          </div>
        </DialogTitle>
        <DialogContent>
          {loading ? (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "60%",
              }}
            >
              <CircularProgress />
            </div>
          ) : (
            <div className="row">
              <div className="col-sm-12" style={{ marginTop: "10px" }}>
                You have selected {selectedData.PreworkDetails.length} documents
                for reprocess
              </div>
              <div className="col-sm-12" style={{ marginTop: "-18px" }}>
                <List>
                  {selectedData.PreworkDetails.map((detail: any) => (
                    <ListItem key={detail.ChildFileDocumentStreamId || detail.ParentDocumentID}>
                      <ListItemIcon sx={{ minWidth: "20px" }}>
                        <FiberManualRecordIcon sx={{ fontSize: "8px" }} />
                      </ListItemIcon>
                      <ListItemText primary={detail.Filename} />
                    </ListItem>
                  ))}
                </List>
              </div>
              <div className="col-sm-12" style={{ marginTop: "8px" }}>
                <p>
                  Your selection contains {selectedData.PreworkDetails.length}{" "}
                  number of files. This move option involves zipping the files
                  and then it will move to the configured FTP/SFTP location.
                </p>
                <p> The larger the format, the longer it will take.</p>
                <p>
                  {" "}
                  Overall entire Move to Preflight of 50 MB files selection,
                  system will take 60 secs under general circumstances.
                </p>
              </div>
              <div className="col-sm-12" style={{ marginTop: "10px" }}>
                Are you sure you want to proceed?
              </div>
            </div>
          )}
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleSendClick}
            style={{
              textTransform: "none",
              borderRadius: "0px",
              backgroundColor: "var(--button-background-color)",
              color: "var(--button-color)",
              fontSize: "11px",
              padding: "5px 12px",
              border: "1px solid #144979",
              margin: "0 5px 20px 5px",
              whiteSpace: "white-space",
            }}
          >
            Yes
          </Button>
          <Button
            style={{
              textTransform: "none",
              borderRadius: "0px",
              backgroundColor: "var(--button-background-color)",
              color: "var(--button-color)",
              fontSize: "11px",
              padding: "5px 12px",
              border: "1px solid #144979",
              margin: "0 20px 20px 5px",
              whiteSpace: "white-space",
            }}
            onClick={handleNoClick}
          >
            No
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};
export default ReprocessSendToPreflight;
